import _ from 'lodash';
import Vue from 'vue';

import {i18n} from '../../plugins/i18n';
import {router} from '../../router';

export default {
  state: {
    favorites: null,
    showFavoritePhoto: false,
    orderFavoritePhotos: false,
    helperMySelectionStep1: false,
    helperMySelectionStep2: false,
  },
  getters: {
    FAVORITES: state => {
      return state.favorites;
    },
    SHOW_FAVORITE_PHOTO: state => {
      return state.showFavoritePhoto;
    },
    ORDER_FAVORITE_PHOTOS: state => {
      return state.orderFavoritePhotos;
    },
    HELPER_MY_SELECTION_STEP_1: state => {
      return state.helperMySelectionStep1;
    },
    HELPER_MY_SELECTION_STEP_2: state => {
      return state.helperMySelectionStep2;
    },
  },
  mutations: {
    SET_FAVORITES: (state, payload) => {
      state.favorites = payload;
    },
    SET_SHOW_FAVORITE_PHOTO: (state, payload) => {
      state.showFavoritePhoto = payload;
    },
    SET_ORDER_FAVORITE_PHOTOS: (state, payload) => {
      state.orderFavoritePhotos = payload;
    },
    SET_HELPER_MY_SELECTION_STEP_1: (state, payload) => {
      state.helperMySelectionStep1 = payload;
    },
    SET_HELPER_MY_SELECTION_STEP_2: (state, payload) => {
      state.helperMySelectionStep2 = payload;
    },
    ADD_FAVORITE: (state, data) => {
      if (!state.favorites) {
        state.favorites = [];
      }
      const albumIndex = _.findIndex(state.favorites,
          {albumId: data.albumId});

      if (state.favorites && albumIndex >= 0) {
        state.favorites[albumIndex].items.push({
          photoId: data.photoId,
          photoPath: data.photoPath,
          freeDownload: data.freeDownload,
        });
      } else {
        state.favorites.push({
          albumId: data.albumId,
          albumTitle: data.albumTitle,
          albumStatus: data.albumStatus,
          albumHash: data.albumHash,
          albumHashPassword: data.albumHashPassword,
          albumPricelist: data.albumPricelist,
          tag: data.tag,
          items: [
            {
              photoId: data.photoId,
              photoPath: data.photoPath,
              freeDownload: data.freeDownload,
            }],
        });
      }

      localStorage.setItem('favorites', JSON.stringify(state.favorites));
    },
    DELETE_FAVORITE: (state, data) => {
      let albumIndex;

      if (data.albumStatus === '2') {
        const albumHash = data.albumId.split('-')[0];
        const albumHashPassword = data.albumId.split('-')[1];
        albumIndex = _.findIndex(state.favorites, {albumHash, albumHashPassword});
      } else {
        albumIndex = _.findIndex(state.favorites, {albumId: data.albumId});
      }

      if (albumIndex >= 0) {
        const photoIndex = _.findIndex(state.favorites[albumIndex].items,
            {photoId: data.photoId});

        if (albumIndex >= 0) {
          state.favorites[albumIndex].items.splice(photoIndex, 1);
        }

        if (!state.favorites[albumIndex].items.length) {
          state.favorites.splice(albumIndex, 1);
        }

        if (!state.favorites.length) {
          state.favorites = null;
        }

        if (state.favorites) {
          localStorage.setItem('favorites', JSON.stringify(state.favorites));
        } else {
          localStorage.removeItem('favorites');
        }
      }
    },
  },
  actions: {
    INIT_FAVORITES: async (context) => {
      if (context.getters.USER) {
        try {
          const favorites = await Vue.axios.get('v2/favorites');

          let data = favorites.data.data;

          let ids = [];
          let localIds = [];

          let output = Object.keys(data).map(function(albumId) {
            let albumTitle = data[albumId].titles[i18n.locale],
                albumStatus = data[albumId].status,
                albumHash = data[albumId].hash,
                albumHashPassword = data[albumId].hash_password,
                albumPricelist = data[albumId].has_pricelist ? +data[albumId].has_pricelist : 0,
                tag = data[albumId].tag ? data[albumId].tag : null;

            let items = Object.keys(data[albumId].items).map(photoId => {
              ids.push(photoId);
              return {
                photoId: photoId,
                photoPath: data[albumId].items[photoId].medium_photo,
                freeDownload: data[albumId].items[photoId].free_download,
              };
            });

            return {
              albumId,
              albumTitle,
              albumStatus,
              albumHash,
              albumHashPassword,
              albumPricelist,
              tag,
              items,
            };
          });

          let localFavorites = JSON.parse(localStorage.getItem('favorites'));

          if (localFavorites) {

            localFavorites.map(localFavorite => {
              localFavorite.items.map(favorite => {
                localIds.push(favorite.photoId);
              });
            });

            let idsArray = await context.dispatch('EXTRACT_FAVORITE_IDS',
                {ids, localIds});

            await Vue.axios.post('v2/favorites', {
              id: idsArray,
            });
          }
          if (localIds.length >= ids.length) {
            context.commit('SET_FAVORITES', localFavorites);
          } else {
            context.commit('SET_FAVORITES', output);
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
        }
      } else {
        let localFavorites = JSON.parse(localStorage.getItem('favorites'));
        context.commit('SET_FAVORITES', localFavorites);
      }
    },
    ADD_FAVORITE: async (context, data) => {
      context.commit('ADD_FAVORITE', data);

      if (context.getters.USER) {
        await Vue.axios.post('v2/favorites', {
          id: data.photoId,
          tag: router.currentRoute.params.tag || '',
        });
      }
    },
    DELETE_FAVORITE: async (context, data) => {
      context.commit('DELETE_FAVORITE', data);

      if (context.getters.USER) {
        await Vue.axios.delete(`v2/favorites/${data.photoId}`, {
          id: data.photoId,
        });
      }
    },
    EXTRACT_FAVORITE_IDS: (context, data) => {
      const obj1 = data.ids.reduce((acc, item) => ({
        ...acc,
        [item]: true,
      }), {});
      return data.localIds.filter(item => !obj1[item]);
    },
    INIT_HELPERS_MY_SELECTION: async (context) => {
      context.commit('SET_HELPER_MY_SELECTION_STEP_1', !!localStorage.getItem('my-selection-step-1'));
      context.commit('SET_HELPER_MY_SELECTION_STEP_2', !!localStorage.getItem('my-selection-step-2'));
    },
    SET_SHOW_FAVORITE_PHOTO: (context, showFavoritePhoto) => {
      context.commit('SET_SHOW_FAVORITE_PHOTO', showFavoritePhoto);
    },
    SET_ORDER_FAVORITE_PHOTOS: (context, orderFavoritePhotos) => {
      context.commit('SET_ORDER_FAVORITE_PHOTOS', orderFavoritePhotos);
    },
    SET_HELPER_MY_SELECTION_STEP_1: (context, helperMySelectionStep1) => {
      context.commit('SET_HELPER_MY_SELECTION_STEP_1', helperMySelectionStep1);
    },
    SET_HELPER_MY_SELECTION_STEP_2: (context, helperMySelectionStep2) => {
      context.commit('SET_HELPER_MY_SELECTION_STEP_2', helperMySelectionStep2);
    },
  },
};